import React, { useState } from 'react';
import axios from 'axios';

const NotificationSender = () => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);


 
  const sendNotification = async () => {
    const formData = new FormData();
    formData.append('registration_id', 'epohZkbkSyKhxBj0EOfEtK:APA91bHMBNEIOrZYhVfjB1CO-s5bGFouDsTbu8tjQLoJ-_G-bpvsE-q7HkTOjo1aT1b3cBHtgv7eh6Yd5UbcaMlmui5vUKvjGONM_GmfLzXsDX4KNlcsDuQ');
    formData.append('title', title);
    formData.append('body', body);
    formData.append('action', 'CERTIFICATE');
    formData.append('notification_type', 'notification_user');


    
        // `/dev/push_notification`, ---> USE THIS LINE IF LOCALHOST AND THIS PROXY https://lvjnc760ah.execute-api.ap-southeast-1.amazonaws.com ON package.json - makukuha mo sa LAMBDA yung url
        //  IF HOSTING USE THE CODE BELOW 
        // `${process.env.REACT_APP_PUSH_NOTIF_URL}/dev/push_notification



    const isDev = process.env.NODE_ENV === 'development';
    const pushNotifUrl = isDev ? '/dev/push_notification' : `${process.env.REACT_APP_PUSH_NOTIF_URL}/dev/push_notification`;

    

    try {
      const result = await axios.post(
        pushNotifUrl,
        formData,
        {
          headers: {
            'x-api-key': 'seNcrQuSuv400Z3T0sOlW5ZtcR5LlCQP10H6qOjB',
            // Do not manually set Content-Type with FormData
          },
        }
      );
      setResponse(result.data);
      setError(null);
      console.log('✅ Notification sent:', result.data);
    } catch (err) {
      const errorMsg = err.response ? err.response.data : err.message;
      setError(errorMsg);
      setResponse(null);
      console.error('❌ Error sending notification:', errorMsg);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendNotification();
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2>🔔 Send Notifications</h2> {process.env.REACT_APP_PUSH_NOTIF_URL}
      <form onSubmit={handleSubmit} style={{ marginBottom: '1em' }}>
        <div>
          <input
            type="text"
            placeholder="Notification Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{ width: '300px', padding: '8px', marginBottom: '10px' }}
          />
        </div>
        <div>
          <input
            type="text"
            placeholder="Notification Body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            style={{ width: '300px', padding: '8px', marginBottom: '10px' }}
          />
        </div>
        <button type="submit" style={{ padding: '10px 20px' }}>
          Send
        </button>
      </form>

      {response && (
        <div style={{ color: 'green' }}>
          ✅ Response: {JSON.stringify(response)}
        </div>
      )}
      {error && (
        <div style={{ color: 'red' }}>
          ❌ Error: {JSON.stringify(error)}
        </div>
      )}
    </div>
  );
};

export default NotificationSender;
